import { cn } from '@/lib/utils'

/**
 * A step code with its description (plans/00 5.7: step codes always carry a
 * description), for example "DE-3 Approve allocation options".
 */
export function StepCode({ code, desc, className }: { code: string; desc?: string | null; className?: string }) {
  return (
    <span className={cn('inline-flex min-w-0 items-center gap-2', className)}>
      <span className='shrink-0 rounded-md bg-primary/10 px-1.5 py-0.5 font-mono text-xs font-semibold text-foreground'>
        {code}
      </span>
      {desc && <span className='truncate text-sm text-foreground'>{desc}</span>}
    </span>
  )
}
